import { render, staticRenderFns } from "./QuestionDetailsTab.vue?vue&type=template&id=0e167cb0&scoped=true&"
import script from "./QuestionDetailsTab.vue?vue&type=script&lang=js&"
export * from "./QuestionDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e167cb0",
  null
  
)

export default component.exports